export default __webpack_public_path__ + "static/media/factory_configuration_card.8d8ae8f7.jpg";